<template>
  <el-table-column
    prop="supplier_name"
    sortable="custom"
    label="Átadó"
    show-overflow-tooltip
    min-width="150"
  />
</template>

<script>
  export default {
    propName: 'supplier_name',
  };
</script>
